import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationCard = ({ notification, onClick }) => {
  const getNotificationIcon = (priority) => {
    switch (priority) {
      case 'critical':
        return { name: 'AlertCircle', color: 'var(--color-error)', bgColor: 'bg-error/10', borderColor: 'border-error' };
      case 'high':
        return { name: 'AlertTriangle', color: 'var(--color-warning)', bgColor: 'bg-warning/10', borderColor: 'border-warning' };
      case 'medium':
        return { name: 'Info', color: 'var(--color-accent)', bgColor: 'bg-accent/10', borderColor: 'border-accent' };
      default:
        return { name: 'Bell', color: 'var(--color-muted-foreground)', bgColor: 'bg-muted', borderColor: 'border-border' };
    }
  };

  const iconConfig = getNotificationIcon(notification?.priority);
  const isUnread = !notification?.is_read;

  return (
    <div
      onClick={onClick}
      className={`flex gap-4 p-4 rounded-lg border ${iconConfig?.borderColor} ${iconConfig?.bgColor} cursor-pointer hover:shadow-md transition-shadow ${
        isUnread ? 'bg-opacity-20' : 'bg-opacity-10'
      }`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          e?.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex-shrink-0 mt-1">
        <div className={`flex items-center justify-center w-10 h-10 rounded-full ${iconConfig?.bgColor}`}>
          <Icon name={iconConfig?.name} size={20} color={iconConfig?.color} />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h4 className={`text-sm font-semibold text-foreground ${
            isUnread ? 'font-bold' : ''
          }`}>
            {notification?.title}
            {isUnread && (
              <span className="ml-2 inline-flex items-center justify-center w-2 h-2 bg-accent rounded-full" />
            )}
          </h4>
          <span className="text-xs text-muted-foreground whitespace-nowrap">
            {notification?.timestamp}
          </span>
        </div>
        <p className="text-sm text-muted-foreground mb-2">
          {notification?.message}
        </p>
        <div className="flex items-center gap-2 flex-wrap">
          {notification?.priority && (
            <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${
              notification?.priority === 'critical' ? 'bg-error/20 text-error' :
              notification?.priority === 'high' ? 'bg-warning/20 text-warning' :
              notification?.priority === 'medium'? 'bg-accent/20 text-accent' : 'bg-muted text-muted-foreground'
            }`}>
              {notification?.priority?.toUpperCase()}
            </span>
          )}
          {notification?.type && (
            <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-muted text-muted-foreground">
              {notification?.type}
            </span>
          )}
        </div>
      </div>
      <div className="flex-shrink-0">
        <Icon name="ChevronRight" size={20} className="text-muted-foreground" />
      </div>
    </div>
  );
};

export default NotificationCard;